import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import theme from '../../../styles/theme';

const featherIcon = require('feather-icons');

const ButtonWrapper = styled.button`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
`;

const IconWrapper = styled.i`
  display: inline-block;
`;

const TopButton = ({
  name,
  size,
  strokeWidth,
  rotate,
  color,
  onClick,
  ...props
}) => {
  const [Scroll, setScroll] = useState(0);
  const [isVisible, setVisible] = useState(false);

  const trackScroll = () => {
    setScroll(window.pageYOffset);
    if (Scroll > 280) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    const scrollWatcher = () => {
      window.addEventListener('scroll', trackScroll);
    };
    scrollWatcher();
    return () => {
      window.removeEventListener('scroll', trackScroll);
    };
  });

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const iconType = {
    primary: theme.colors.primary,
    dark: theme.colors.gray700,
  };

  const shapeStyle = {
    width: size,
    height: size,
    transform: rotate ? `rotate(${rotate}deg)` : undefined,
  };

  const iconStyle = {
    'stroke-width': strokeWidth,
    stroke: Object.keys(iconType).includes(color) ? iconType[color] : color,
    width: size,
    height: size,
    color: Object.keys(iconType).includes(color) ? iconType[color] : color,
  };

  const icon = featherIcon.icons[name];
  const svg = icon ? icon.toSvg(iconStyle) : '';
  const base64 = Buffer.from(svg, 'utf8').toString('base64');

  return (
    <ButtonWrapper {...props} isVisible={isVisible} onClick={toTop}>
      <IconWrapper style={{ ...props.style, ...shapeStyle }}>
        <img src={`data:image/svg+xml;base64,${base64}`} alt={name} />
      </IconWrapper>
    </ButtonWrapper>
  );
};

TopButton.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  rotate: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

TopButton.defaultProps = {
  name: 'chevrons-up',
  size: theme.iconSizes.xl,
  strokeWidth: 2,
  rotate: 0,
  color: 'primary',
  onClick: () => {},
  style: {},
};

export default TopButton;
